import { FC, useCallback, useState } from 'react';
import classNames from 'classnames';

import { ActionMenu, Icon, Stack } from '@servicetitan/design-system';
import { tokens } from '@servicetitan/tokens/core';

import { AvatarIcon } from './avatar-icon';

import * as HeaderStyles from './header.module.less';

export const ProfileDropdown: FC<{ user: string }> = ({ user }) => {
    const [state, setState] = useState(false);

    const handlerToggle = useCallback(() => {
        setState(!state);
    }, [state]);

    const trigger = (
        <Stack
            className={classNames(HeaderStyles.navItem, { [HeaderStyles.active]: state })}
            alignItems="center"
            direction="row"
            onClick={handlerToggle}
        >
            <AvatarIcon color={state ? tokens.colorBlue200 : undefined} />
            <Icon name={state ? 'expand_less' : 'expand_more'} />
        </Stack>
    );

    return (
        <ActionMenu
            trigger={trigger}
            open={state}
            onClickOutside={handlerToggle}
            className="m-t-3 m-r-2 border-i"
        >
            <ActionMenu.Group>
                <ActionMenu.Item disabled>
                    <Stack wrap="nowrap" alignItems="center">
                        <Icon name="account_circle" size={20} className="m-r-2" /> {user}
                    </Stack>
                </ActionMenu.Item>
            </ActionMenu.Group>
        </ActionMenu>
    );
};
